import { useTranslation } from "react-i18next";
import { InfoRow } from "./InfoRow";
import { FormInstance } from "antd";
import React from "react";
import { borderGatesData } from "../../../constants";

interface OthersInfoField {
  key: string;
  label: string;
  value: string;
  editable?: boolean;
}

interface OthersInfoProps {
  form: FormInstance<IVisaRequestFormData>;
  handleEditClick?: (field: string) => void;
}

const OthersInfo: React.FC<OthersInfoProps> = ({ form, handleEditClick }) => {
  const { t } = useTranslation();

  const formatProvinceName = (str: string, type: string = "none") => {
    return type === "province"
      ? str
          .replace(/_/g, " ")
          .replace(/^(Thanh Pho|Tinh)\s+/i, "")
          .toUpperCase()
      : str.replace(/_/g, " ").toUpperCase();
  };

  const othersFields: OthersInfoField[] = [
    {
      key: "entry_purpose",
      label: t("registration_form.step6.entry_purpose"),
      value: form.getFieldValue("entry_purpose") || "",
      editable: true,
    },
    {
      key: "intended_date_of_entry",
      label: t("registration_form.step6.intended_date_of_entry"),
      value: form.getFieldValue("intended_date_of_entry")
        ? form.getFieldValue("intended_date_of_entry").format("DD-MM-YYYY")
        : "",
      editable: true,
    },
    {
      key: "intended_length_of_stay",
      label: t("registration_form.step6.intended_length_of_stay"),
      value: `${form.getFieldValue("intended_length_of_stay") || ""} ${
        localStorage.getItem("i18nextLng") === "en"
          ? " days"
          : localStorage.getItem("i18nextLng") === "jp"
          ? "日間"
          : localStorage.getItem("i18nextLng") === "kr"
          ? "일"
          : "天"
      }`,
      editable: true,
    },
    {
      key: "vietnam_phone_number",
      label: t("registration_form.step6.number_in_vn"),
      value: form.getFieldValue("vietnam_phone_number") || "",
      editable: true,
    },
    {
      key: "vietnam_residental_address",
      label: t("registration_form.step6.address_in_vn"),
      value:
        formatProvinceName(form.getFieldValue("ward") || "") +
        ", " +
        formatProvinceName(form.getFieldValue("district") || "") +
        ", " +
        formatProvinceName(form.getFieldValue("province") || "", "province"),
      editable: true,
    },
    {
      key: "intended_entry_border_gate",
      label: t("registration_form.step6.intended_border_gate_of_entry"),
      value:
        borderGatesData.find(
          (gate) =>
            gate.code === form.getFieldValue("intended_entry_border_gate")
        )?.name[localStorage.getItem("i18nextLng") as string] || "",
      editable: true,
    },
    {
      key: "intended_exit_border_gate",
      label: t("registration_form.step6.intended_border_gate_of_exit"),
      value:
        borderGatesData.find(
          (gate) =>
            gate.code === form.getFieldValue("intended_exit_border_gate")
        )?.name[localStorage.getItem("i18nextLng") as string] || "",
      editable: true,
    },
    { key: "empty", label: "", value: "", editable: false },
    // {
    //   label: t("registration_form.step5.current_occupation"),
    //   value: form.getFieldValue("occupation") || "",
    //   editable: true
    // },
    // {
    //   label: t("registration_form.step5.occupation_info"),
    //   value: form.getFieldValue("occupation_info") || "",
    //   editable: true
    // },
    // {
    //   label: t("registration_form.step5.company_name"),
    //   value: form.getFieldValue("company_name") || "",
    //   editable: true
    // },
    // {
    //   label: t("registration_form.step5.position"),
    //   value: form.getFieldValue("position_of_study") || "",
    //   editable: true
    // },
    // {
    //   label: t("registration_form.step5.company_address"),
    //   value: form.getFieldValue("company_address") || "",
    //   editable: true
    // },
    // {
    //   label: t("registration_form.step5.company_phone_number"),
    //   value: form.getFieldValue("company_phone_number") || "",
    //   editable: true
    // }
  ];

  return (
    <div className="max-w-7xl mx-auto py-4">
      <div className="grid grid-cols-1 md:grid-cols-2">
        {othersFields.map((field) => (
          <InfoRow
            key={field.label}
            fieldKey={field.key}
            label={field.label}
            value={field.value}
            editable={field.editable}
            handleEditClick={handleEditClick}
          />
        ))}
      </div>
    </div>
  );
};

export default OthersInfo;
